"use client";

import { Link } from "@/i18n/routing";

import { useTranslations } from "next-intl";

import EmptyState from "@/ui/Common/EmptyState";

interface NotFoundPageProps {
  title?: string;
  description?: string;
  backLink?: string;
  backText?: string;
  homeText?: string;
  homeLink?: boolean;
}

export default function NotFoundPage({
  title,
  description,
  backLink,
  backText,
  homeText,
  homeLink = true,
}: NotFoundPageProps) {
  const t = useTranslations("common");

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] py-[5rem] px-4">
      <EmptyState
        title={title || t("not_found")}
        className="flex flex-col items-center justify-center"
      />

      {description && (
        <p className="text-gray-600 mb-6 text-lg text-center max-w-screen-md mx-[2rem] md:mx-0">
          {description}
        </p>
      )}

      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        {backLink && (
          <Link
            href={backLink}
            className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors font-medium text-sm text-center"
          >
            {backText || t("go_back")}
          </Link>
        )}

        {homeLink && (
          <Link
            href="/"
            className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium text-sm text-center"
          >
            {homeText || t("go_home")}
          </Link>
        )}
      </div>
    </div>
  );
}
